import React from 'react'
import MainBanner from './MainBanner'

import whiterightarrow from "../../assets/images/white-rightarrow.svg";
import blackrightarrow from "../../assets/images/blackrightarrow.svg";
import sideCartimg from "../../assets/images/medicoimg.png";
import Contactus from "../Common/Contactus";
import uploadicon from "../../assets/images/uploadicon.png";
import closeicon from "../../assets/images/closeicon.svg";
import redefineculture from "../../assets/images/redefineculture.svg";
import PioneeringInnovativeThinking from "../../assets/images/Pioneering-Innovative-Thinking.svg";
import NurturingGrowth from "../../assets/images/Nurturing-Growth.svg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const MedicoContent = () => {
    return (
        <>
            <div>
                <MainBanner page="PRODUCTS" />
                <section className=" aboutsection2" id="single-product">
                    <div className="container ">
                        <div className="bg-white">
                            <div className="text-section">
                                <h2 className="text-purple">Medico</h2>
                                <p className="fw-medium">Health Care</p>
                                <div>
                                    Online Marketplace:&nbsp;Medico Website is a comprehensive healthcare platform designed to connect patients, doctors, and healthcare providers seamlessly. The goal is to build a user-centric, responsive, and secure website that caters to the growing need for accessible medical services online. The platform will serve as a hub for users to book appointments, access health information, and connect with medical professionals.
                                </div>
                                <div>
                                    Product Catalogue:&nbsp;The website will feature an intuitive interface where patients can easily register, search for specialists by location, expertise, or availability, and book appointments. Doctors will have personalized profiles displaying their qualifications, specialties, and patient reviews, enabling better decision-making for users. The site will also host an integrated health blog offering articles, tips, and medical news to keep users informed about various conditions and treatments.
                                </div>
                                <div className="d-flex">
                                    <a
                                        href="#demo-modal"
                                        className="btn btn-black btn-purple  text-white"
                                    >
                                        View Project
                                        <img src={whiterightarrow} alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="image-section">
                                <img src={sideCartimg} alt="" />
                            </div>
                        </div>
                        <div id="demo-modal" className="modal">
                            <div className="modal__content">
                                <h2 className="text-purple">Get A Free Demo</h2>
                                <p className="fw-medium">
                                    Embrace Opportunity: A Pathway to Success
                                </p>
                                <div className="form-container">
                                    <div className="form-group">
                                        <label htmlFor="product">Select Product:</label>
                                        <select id="product" name="product">
                                            <option value="product1">Comercio</option>
                                            <option value="product2">Product 2</option>
                                            <option value="product3">Product 3</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Name:</label>
                                        <input
                                            type="text"
                                            id="name"
                                            placeholder="MCL"
                                            name="name"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            type="email"
                                            placeholder="info@gmail.com"
                                            id="email"
                                            name="email"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone:</label>
                                        <input
                                            type="tel"
                                            placeholder="+91 9896570012"
                                            id="phone"
                                            name="phone"
                                            required
                                        />
                                    </div>
                                    <div className="form-group full-width">
                                        <label htmlFor="message">Message:</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            placeholder="Enter your message here"
                                            required
                                            defaultValue={""}
                                        />
                                    </div>
                                    <div className="form-group full-width button">
                                        <button className="btn btn-black" type="submit">
                                            Get a demo
                                        </button>
                                    </div>
                                </div>
                                <a href="#" className="modal__close">
                                    <img src={closeicon} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className id="Comercio-discription">
                    <div className="container ">
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold"> User-Friendly Interface:&nbsp;</span>
                                The platform offers an intuitive, easy-to-navigate design that enables users to find healthcare professionals, book appointments, and access information effortlessly.

                            </div>
                            <div>
                                <span className="fw-semi-bold">Doctor Profiles:</span>
                                Medical professionals have detailed profiles showcasing their expertise, qualifications, and patient reviews, helping patients make informed choices.

                            </div>
                            <div>
                                <span className="fw-semi-bold">Appointment Booking:&nbsp;</span>
                                Users can easily schedule appointments with doctors through the platform, based on their availability and location, streamlining the entire booking process.

                            </div>

                        </div>
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold">
                                Health Blog & Resources:&nbsp;
                                </span>
                                The site includes a blog section with articles, tips, and news on various health topics, providing users with valuable information on medical conditions and treatments.

                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                Secure Data Management:&nbsp;
                                </span>
                                &nbsp;Advanced security features ensure that patient data and personal information are protected through encryption and secure data storage practices.

                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                Mobile Optimization:
                                &nbsp;&nbsp;
                                </span>
                                &nbsp;The platform is fully responsive and optimized for mobile devices, offering users a seamless experience across different screen sizes, ensuring accessibility on the go.

                            </div>
                        </div>
                    </div>
                </section>
                <Contactus />
            </div>
        </>
    )
}

export default MedicoContent